import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import { useEffect } from 'react';
import { noop } from '../utils/functions.js';
import useQueue from './useQueue.js';

var _excluded = ["key", "head", "pop"];

var useTimedQueue = function useTimedQueue(interval) {
  var initial = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  var _useQueue = useQueue(initial),
      key = _useQueue.key,
      head = _useQueue.head,
      pop = _useQueue.pop,
      rest = _objectWithoutProperties(_useQueue, _excluded);

  useEffect(function () {
    if (!head) {
      return noop;
    }

    var timeoutId = setTimeout(function () {
      return pop();
    }, interval);
    return function () {
      return clearTimeout(timeoutId);
    };
  }, [key, head, pop, interval]);
  return _objectSpread({
    key: key,
    head: head,
    pop: pop
  }, rest);
};

var useTimedQueue$1 = useTimedQueue;

export { useTimedQueue$1 as default };
